export const buildEnv = {
  // @ts-ignore, as typescript doesn't know about vitejs
  appRevision: import.meta.env.VITE_APP_REVISION,
  // @ts-ignore
  railsEnv: import.meta.env?.VITE_RAILS_ENV,
};
